 import type { FC } from 'react'
import { ToolTipProps } from '../../type/components'
import { Tooltip } from '@mui/material'
 
const CustomToolTip: FC<ToolTipProps> = ({title, isArrow=false, placement="top",children}) => {
  return (
    <div>
        <Tooltip title={title} arrow={isArrow} placement={"top"}  
            componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: '#23272c',
                    color: 'white',
                    fontSize: '14px',
                  },
                },
                arrow: {
                  sx: {
                    color: '#23272c', // Arrow color must match background
                  },
                },
              }}                  
            >
            <div>
              {children}
            </div>
      </Tooltip>
    </div>
  )
}

export default CustomToolTip

 